module.exports = __webpack_public_path__ + "static/media/6.9.1ec5b442.png";